import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { Link } from '@inertiajs/react';
import { ArrowRight, type LucideIcon } from 'lucide-react';

interface GovernanceCardProps {
    icon: LucideIcon;
    title: string;
    description: string;
    href: string;
}

export default function GovernanceCard({ icon: Icon, title, description, href }: GovernanceCardProps) {
    return (
        <Card className="border-border group h-full rounded-2xl bg-white/95 py-0 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:border-emerald-500/20 hover:shadow-md dark:bg-[oklch(0.18_0_0)]">
            <CardHeader className="gap-4 p-6">
                <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-[#0A7A35]/10 text-[#0A7A35] transition-transform duration-300 group-hover:scale-105 dark:text-[#21d36b]">
                    <Icon className="h-6 w-6" aria-hidden="true" />
                </div>
                <div className="space-y-2">
                    <CardTitle className="text-foreground text-lg font-bold">{title}</CardTitle>
                    <CardDescription className="text-muted-foreground text-sm leading-relaxed">{description}</CardDescription>
                </div>
            </CardHeader>
            <CardContent className="px-6 pb-2" />
            <CardFooter className="p-6 pt-0">
                <Button asChild className="rounded-full bg-[#00963f] text-white hover:bg-[#008538]">
                    <Link href={href} prefetch aria-label={`Learn more about ${title}`}>
                        Learn More
                        <ArrowRight className="h-4 w-4" />
                    </Link>
                </Button>
            </CardFooter>
        </Card>
    );
}
